import React from 'react';
import { FaClock, FaCalendarAlt, FaRegCalendarCheck, FaRegClock, FaArrowRight } from 'react-icons/fa';

export default function TimeTableSection() {
    return (
        <section className="py-20 bg-white">
            <div className="max-w-6xl mx-auto px-6">
                {/* Modern Header */}
                <div className="text-center mb-16">
                    <div className="inline-block mb-6">
                        <div className="flex items-center gap-2 bg-blue-50 border border-blue-200 rounded-2xl px-6 py-3 shadow-sm">
                            <FaClock className="text-blue-600 text-lg" />
                            <span className="text-blue-700 font-semibold text-sm lemon-milk">CLASS SCHEDULES</span>
                        </div>
                    </div>

                    <h2 className="text-4xl font-black text-gray-900 mb-4 lemon-milk">
                        Time <span className="text-blue-600">Tables</span>
                    </h2>

                    <p className="text-lg text-gray-600 max-w-2xl mx-auto poppins">
                        Choose your academic year and access detailed class schedules designed for your success.
                    </p>
                </div>

                {/* Modern Time Table Cards */}
                <div className="grid md:grid-cols-3 gap-6">
                    {/* 2025 Classes */}
                    <div className="group relative">
                        <div className="absolute inset-0 bg-blue-500 rounded-2xl transform rotate-1 group-hover:rotate-0 transition-transform duration-300 opacity-10"></div>
                        <div className="relative bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 text-center">
                            <div className="w-16 h-16 bg-blue-600 rounded-2xl mx-auto mb-6 flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                                <FaCalendarAlt className="text-white text-xl" />
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-3 lemon-milk">2025 Classes</h3>
                            <p className="text-gray-600 text-sm mb-4 poppins">Current academic year schedules and timetables</p>
                            <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 px-4 py-2 rounded-lg text-sm font-medium">
                                <span>View Schedule</span>
                                <FaArrowRight className="text-xs" />
                            </div>
                        </div>
                    </div>

                    {/* 2026 Classes */}
                    <div className="group relative">
                        <div className="absolute inset-0 bg-gray-500 rounded-2xl transform -rotate-1 group-hover:rotate-0 transition-transform duration-300 opacity-10"></div>
                        <div className="relative bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 text-center">
                            <div className="w-16 h-16 bg-gray-600 rounded-2xl mx-auto mb-6 flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                                <FaRegCalendarCheck className="text-white text-xl" />
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-3 lemon-milk">2026 Classes</h3>
                            <p className="text-gray-600 text-sm mb-4 poppins">Next year's planned schedules and course timings</p>
                            <div className="inline-flex items-center gap-2 bg-gray-50 text-gray-700 px-4 py-2 rounded-lg text-sm font-medium">
                                <span>View Schedule</span>
                                <FaArrowRight className="text-xs" />
                            </div>
                        </div>
                    </div>

                    {/* 2027 Classes */}
                    <div className="group relative">
                        <div className="absolute inset-0 bg-blue-400 rounded-2xl transform rotate-1 group-hover:rotate-0 transition-transform duration-300 opacity-10"></div>
                        <div className="relative bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 text-center">
                            <div className="w-16 h-16 bg-blue-500 rounded-2xl mx-auto mb-6 flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                                <FaRegClock className="text-white text-xl" />
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-3 lemon-milk">2027 Classes</h3>
                            <p className="text-gray-600 text-sm mb-4 poppins">Future academic year planning and schedules</p>
                            <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 px-4 py-2 rounded-lg text-sm font-medium">
                                <span>View Schedule</span>
                                <FaArrowRight className="text-xs" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Additional Info Section */}
                <div className="mt-12 bg-gray-50 rounded-2xl p-8 text-center">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4 lemon-milk">Need Help with Scheduling?</h3>
                    <p className="text-gray-600 mb-6 poppins">Our academic advisors are here to help you plan your perfect study schedule.</p>
                    <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors lemon-milk">
                        Contact Academic Support
                    </button>
                </div>
            </div>
        </section>
    );
}
